export default function WeekdayLetter(value: Date | null) {
    if (!value) return '';
    return value.toLocaleDateString('en-US', { weekday: 'long' })[0];
}
